import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-mensaje',
  templateUrl: './info-mensaje.component.html',
  styleUrls: ['./info-mensaje.component.scss']
})
export class InfoMensajeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
